import { createReducer, on } from '@ngrx/store';

import { AuthState } from '../models/auth-state';
import { logout, setAccessToken, setDsToken, setRefreshToken, setReloginUrl } from './auth.actions';

const initialState: AuthState = {
  dsToken: null,
  accessToken: null,
  refreshToken: null,
  reloginUrl: null,
};

export const authReducer = createReducer(
  initialState,
  on(setDsToken, (state, { dsToken }) => ({ ...state, dsToken })),
  on(setAccessToken, (state, { accessToken }) => ({ ...state, accessToken })),
  on(setRefreshToken, (state, { refreshToken }) => ({ ...state, refreshToken })),
  on(setReloginUrl, (state, { reloginUrl }) => ({ ...state, reloginUrl })),
  on(logout, () => ({ ...initialState }))
);
